import 'current-device';
import Header from '../__header/Header';
import Accordion from '../__shortcodes/accordions';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import vhUnit from '../__utils/vhUnit';
import SubNav from '../__header/SubNav';
import BookBar from '../__page/BookBar';
import forms from '../__utils/forms';
import Modal from '../__utils/modal';
import modalTable from '../__utils/modalTable';
import { AlertTop, AlertBottom } from '../__header/AlertBar';
import { AcccomodationHeroSlider, AccommodationSliderRelated, CulinaryRelatedSlider } from '../__utils/sliders';
import woocommerceSelect from '../__woocommerce/select';
import woocommerceAjaxLoadMoreInit from '../__woocommerce/ajaxLoadMore';
import categoriesDropdownInit from '../__woocommerce/categoriesDropdown';
import woocommerceNumberFieldsInit from '../__woocommerce/numberFields';
import tabsToAccordionInit from '../__woocommerce/productTabsToAccordion';
import contentAnimations from '../__utils/animations';
import equalHeightElements from '../__utils/equalHeightElements';

const $ = jQuery.noConflict();

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js');
        document.documentElement.dataset.browser = navigator.userAgent;
        Header.init();
        Accordion.init();
        Video.init();
        mirrorHover();
        smoothScroll();
        Tables.init();
        vhUnit();
        SubNav.init();
        BookBar.init();
        AlertTop.init();
        AlertBottom.init();
        Modal.init();
        modalTable();
		woocommerceSelect();
		woocommerceAjaxLoadMoreInit();
		categoriesDropdownInit();
		woocommerceNumberFieldsInit();
		contentAnimations();
    },
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded');
        vhUnit();
        AcccomodationHeroSlider.init();
        AccommodationSliderRelated.init();
        CulinaryRelatedSlider.init();
		tabsToAccordionInit();
		equalHeightElements('.single-culinary-related .culinary-card__content', '991px');
    },
    resized() {
		Header.resized();
        Tables.toggleShadow();
        vhUnit();
        modalTable();
    },
    scrolled() {

    },
    keyDown(e){

    },
    scrolled() {

    },
    keyDown(e){

    },
    gformRender() {
		forms();
	},
    mouseUp(e) {
    },

	orientationChange() {
		Header.orientation();
    },
};
export default controller;
